<template>
  <section class="bx-content bx-table bx-typo--table">
    <span class="bx-table__headline">
      {{ title }}
    </span>

    <table v-if="rows && rows.length"
           class="bx-table__wrapper"
           :aria-label="title">
      <colgroup>
        <col v-for="(col, index) in colwidths"
             :key="'col' + index"
             :style="col ? 'width: ' + col + 'px;' : 'min-width: 25px;' ">
      </colgroup>
      <tr v-for="(row, index) in rows"
          :key="index"
          class="bx-table__row">
        <template v-for="(cell, cellIndex) in row">
          <th v-if="cell.type === 'tableHeader'"
              :key="'th' + cellIndex"
              class="bx-table__content bx-typo--content-continuous-text"
              :colspan="cell.attrs.colspan"
              :rowspan="cell.attrs.rowspan"
              v-html="cell.content" />
          <td v-else
              :key="'td' + cellIndex"
              class="bx-table__content bx-typo--content-continuous-text"
              :colspan="cell.attrs.colspan"
              :rowspan="cell.attrs.rowspan"
              v-html="cell.content" />
        </template>
      </tr>
    </table>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    rows: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    colwidths () {
      if (this.rows && this.rows.length && this.rows[0].length) {
        return this.rows[0].map((cell) => {
          const { colwidth } = cell.attrs
          return colwidth ? colwidth[0] : undefined
        })
      }
      return []
    }
  }
}
</script>
